import React from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import {
  BACKGROUND_COLORS,
  BORDER_COLORS,
  SHADOW_COLORS,
  TEXT_COLORS,
} from "../../../style/colors";

const AppDialog = ({
  open,
  onClose,
  title,
  headerActions = null,
  actions = null,
  children,
  maxWidth = "md",
  fullWidth = true,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      PaperProps={{
        sx: {
          borderRadius: 3,
          border: `1px solid ${BORDER_COLORS.PRIMARY}`,
          backgroundColor: BACKGROUND_COLORS.CARD,
          boxShadow: `0px 14px 36px ${SHADOW_COLORS.PRIMARY}1f`,
        },
      }}>
      <DialogTitle sx={{ pb: 1.5 }}>
        <Box display='flex' justifyContent='space-between' alignItems='center' gap={2}>
          <Typography
            component='div'
            sx={{
              fontSize: "1.1rem",
              fontWeight: 700,
              color: TEXT_COLORS.PRIMARY,
            }}>
            {title}
          </Typography>
          {headerActions}
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pt: 1.5 }}>{children}</DialogContent>
      {actions ? <DialogActions sx={{ px: 3, pb: 2.5 }}>{actions}</DialogActions> : null}
    </Dialog>
  );
};

export default AppDialog;
